export default {
	computed: {
		showLabel() {
			return !this.hideLabel && this.$source.label && this.$source.label.trim().length;
		}
	}
};
